import React, { useState } from "react";
import { Flex, Typography, Button, Modal, Rate, Input, message } from "antd";
import CONSTANTS from "shared/constants";
import ApiManager from "resources/ApiManager/api";
import strings from "resources/strings";
import { useStore } from "store";

import { NotificationOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { TextArea } = Input;

import "./style.scss";

export default function ModalFeedbackBubble() {
  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const active_rfc_obj = user.rfcs[activeRfc];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [starCount, setStarCount] = useState(0);
  const [feedbackText, setFeedbackText] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsLoading(false);
    setStarCount(0);
    setFeedbackText(null);
    setIsModalOpen(false);
  };

  const handleConfirmation = async () => {
    setIsLoading(true);

    const apiRes = await ApiManager.postUserFeedback(
      starCount,
      feedbackText,
      active_rfc_obj.rfc,
      active_rfc_obj.sat_fiscal_name
    );

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code !== 2000) {
      message.error(strings.alertUnexpectedError);
      return;
    }

    message.success(strings.alertFeedbackSentSuccess, 10);
    setIsLoading(false);
    setStarCount(0);
    setFeedbackText(null);
    setIsModalOpen(false);
  };

  const startsUpdated = (value) => {
    setStarCount(value);
  };

  const feedbackTextUpdated = (e) => {
    setFeedbackText(e.target.value);
  };

  return (
    <>
      <Button
        icon={
          <NotificationOutlined style={{ color: "white", fontSize: "12px" }} />
        }
        type="primary"
        size="small"
        shape="circle"
        style={{
          backgroundColor: "#1C5676",
          marginTop: "-2px",
          marginRight: "5px",
        }}
        onClick={showModal}
      />
      <Modal
        title="Enviar retroalimentación"
        open={isModalOpen}
        onOk={handleConfirmation}
        onCancel={handleCancel}
        width={560}
        destroyOnClose={true}
        footer={null}
        closable={!!!isLoading}
        maskClosable={!!!isLoading}
      >
        <Flex vertical gap={30}>
          <Flex vertical gap={20}>
            <Text>¡Califica tu experiencia y envíanos tus comentarios!</Text>
            <Flex justify="center">
              <Rate style={{ fontSize: 30 }} onChange={startsUpdated} />
            </Flex>
            <TextArea
              rows={4}
              placeholder="¡Agrega tus comentarios!"
              maxLength={1000}
              onChange={feedbackTextUpdated}
            />
          </Flex>
          <Flex justify="flex-end">
            <Button
              type="primary"
              onClick={handleConfirmation}
              loading={isLoading}
              disabled={starCount <= 0}
            >
              Enviar
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
}
